import { Media } from '@/models/media.model';
import { StoryItem } from '@/models/story-item.model';
import { TranslationState } from '@/models/translation.model';
import { Category } from './category.model';
import { UserLabel } from './label.model';
import { Initiative } from './initiative.model';

export enum StoryType {
  Story = 'story',
  Quiz = 'quiz',
}

export interface Story {
  id: number;
  title: string;
  notificationCTA: string;
  type: StoryType;
  index: number;
  items: StoryItem[];
  media: Media[];
  mainCategory?: Category;
  categories: Category[];
  initiativeOfTheDay: Initiative | null;
  published: boolean;
  translated?: TranslationState;
  notRelevantForlabels: UserLabel[];
}

export const titleRules = [
  (value: string) => {
    if (value) return true;

    return 'Title is required.';
  },
];

export const notificationCTARules = [
  (value: string) => {
    if (!value || value.length < 150) return true;

    return 'Please keep this short';
  },
];
